export default "/_next/static/images/NewPlayIconDesktop-dec4c789db106f7ba0bca3e18217ace5.svg";